import React, {Component} from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import {CHARACTERISTIC_ICON_NAMES, CHARACTERISTIC_ICONS} from '../util/characteristicIcons';

/**
 * Grid of ~25 curated MUI icons for picking a characteristic icon.
 * Props: value (current icon name), onChange(iconName).
 */
class CharacteristicIconPicker extends Component {
  render() {
    const {value, onChange} = this.props;
    return (
      <div
        style={{display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8}}
        data-testid="characteristic-icon-picker"
      >
        {CHARACTERISTIC_ICON_NAMES.map((name) => {
          const IconCmp = CHARACTERISTIC_ICONS[name];
          const selected = value === name;
          return (
            <Tooltip key={name} title={name}>
              <span
                role="button"
                tabIndex={0}
                data-testid={`char-icon-${name}`}
                onClick={() => onChange && onChange(name)}
                onKeyDown={(e) => e.key === 'Enter' && onChange && onChange(name)}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 36,
                  height: 36,
                  borderRadius: 4,
                  cursor: 'pointer',
                  border: selected ? '2px solid #1976d2' : '2px solid transparent',
                  background: selected ? '#e3f0ff' : '#f5f5f5',
                }}
              >
                <IconCmp style={{fontSize: 20, color: selected ? '#1976d2' : '#546e7a'}} />
              </span>
            </Tooltip>
          );
        })}
      </div>
    );
  }
}

export default CharacteristicIconPicker;
